import React from 'react'
import './layout.css'

const TitleBar = (props) => {
    return (
        <div>
            <div className="container-fluid mb-8 title-bg-summer">
            <div className="container">
                <h1 className="page-title" style={{paddingBottom: '1.1rem', paddingTop: '1.75rem'}}>{ props.pageTitle }</h1>
            </div>
            </div>
        </div>
    )
}

export default TitleBar